import React from 'react';
import * as styles from './Field.module.scss';
import classNames from 'classnames';

export default function Field({
  inputId,
  label,
  labelId,
  errorId,
  labelClassName,
  className,
  children,
  maxWidth,
  style = {},
  size,
  inlineLabel,
  errorMessage,
  showErrorMessage,
  ...restProps
}) {
  return (
    <div
      className={classNames('field', styles.wrapper, className, {
        [styles.inlineLabel]: inlineLabel,
        [styles.small]: size === 'small'
      })}
      style={{ ...style, maxWidth }}
      {...restProps}
    >
      {label && (
        <label
          id={labelId}
          htmlFor={inputId}
          className={classNames(styles.label, labelClassName)}
        >
          {label}
        </label>
      )}
      {children}
      {showErrorMessage && errorMessage && (
        <div
          id={errorId}
          className={styles.validation}
        >
          {errorMessage}
        </div>
      )}
    </div>
  );
}
